import React from 'react';
import { useNavigate } from 'react-router-dom';
import UserLayout from './UserLayout';
import PeopleDetailContent from './PeopleDetailContent';

const DASHBOARD_PAGE_KEY = 'cabaza_dashboard_page';

/**
 * Dashboard People Detail Page
 * Full page with layout (header, menu, content, footer)
 */
const PeopleDetail = ({ onLogout }) => {
    const navigate = useNavigate();

    // Get the current dashboard page from localStorage to highlight correct menu item
    const currentDashboardPage = localStorage.getItem(DASHBOARD_PAGE_KEY) || 'contacts';

    // Handle navigation from menu - save page and go to dashboard
    const handleNavigate = (page) => {
        localStorage.setItem(DASHBOARD_PAGE_KEY, page);
        navigate('/');
    };

    return (
        <UserLayout
            currentPage={currentDashboardPage}
            onNavigate={handleNavigate}
            onLogout={onLogout}
        >
            <PeopleDetailContent />
        </UserLayout>
    );
};

export default PeopleDetail;
